export const ENROLLMENT_STATE_REQUESTS_FETCH_REQUEST = "ENROLLMENT_STATE_REQUESTS_FETCH_REQUEST";
export const ENROLLMENT_STATE_REQUESTS_FETCH_SUCCESS = "ENROLLMENT_STATE_REQUESTS_FETCH_SUCCESS";
export const ENROLLMENT_STATE_REQUESTS_FETCH_ERROR = "ENROLLMENT_STATE_REQUESTS_FETCH_ERROR";

export const INSTRUMENT_UNENROLLMENT_REQUEST = "INSTRUMENT_UNENROLLMENT";
export const INSTRUMENT_UNENROLLMENT_SUCCESS = "INSTRUMENT_UNENROLLMENT_SUCCESS";
export const INSTRUMENT_UNENROLLMENT_ERROR = "INSTRUMENT_UNENROLLMENT_ERROR";
export const CLAER_INSTRUMENT_FROM_UNENROLLMENT_LIST="CLAER_INSTRUMENT_FROM_UNENROLLMENT_LIST";

export const INSTRUMENT_UNENROLLMENT_UNMOUNT_CONDITION = "INSTRUMENT_UNENROLLMENT_UNMOUNT_CONDITION";
export const PATTERN_VALIDATION_ERROR = "pattern";
export const UNENROLLMENT_MODAL_TITLE= "DEVICE UNENROLLMENT";
export const CUSTOMER_NAME= "Customer Name : ";
export const COUNTRY= "Country : ";
export const SITE_NAME= "Site Name : ";
export const SITE_ADDRESS= "Site Address : ";
export const UNENROLLMENT_CONFIRAMTION_MESSAGE= "Are you sure, you want to un-enroll selected instrument? ";
export const ERROR_MESSAGE= "Instrument cannot be added to un-enrollment list";
export const UNENROLLMENT_GENERIC_ERROR_MESSAGE= "Instrument cannot be added to un-enrollment list";
export const INSTANCE_EXISTS_ERROR="Instance Already Exists";
export const INSTANCE_COUNT_EXCEED_ERROR_MESSAGE="The Instances exceeds the configured number. Cannot add instances further to list to unenroll";
export const UNENROLLMENT_SUCCESSFULL_MESSAGE = "All the instances are unenrolled successfully from Cloud."


